/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { currency } from 'resources/utilities';
import { useGlobalState } from 'resources/GlobalStateContext';
import SLUGS from 'resources/slugs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import AsyncSelectTextField from 'components/Input/AsyncSelectTextField';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useUIUtils } from 'hooks/useUIUtils';

const $ = require('jquery')
$.DataTable = require('datatables.net-select')

const DiferenciasArt = ({ history, match }) => {
    const { path } = match;
    const baseUrl = process.env.REACT_APP_API_URL;
    const { t } = useTranslation("common");
    const [connection, setConnection] = useState(null);
    const { setGlobalTitulo } = useGlobalState();
    const [fechaInicio, setFechaInicio] = useState(GetFecha());
    const [isOpenModal, openModal, closeModal] = useModal(false);
    const [anchorElHerramientas, setAnchorElHerramientas] = useState(null);
    const openHerramientas = Boolean(anchorElHerramientas);
    const [modalValor, setModalValor] = useState(false);
    const [modelPaginate, setModelPaginate] = useState({ page: 0, pageSize: 10 });
    const [buscar, setBuscar] = useState('');
    let [articuloId, setArticuloId] = useState(0);
    let [sucursal, setSucursal] = useState({});
    let [listaPrecio, setListaPrecio] = useState([]);
    let [almacenes, setAlmacenes] = useState([]);
    let [marcas, setMarcas] = useState([]);
    let [categoria, setCategoria] = useState();
    let [filtroTipo, setFiltroTipo] = useState('T');
    let [marca, setMarca] = useState('');
    let [erp, setERP] = useState('');
    let [tienda, setTienda] = useState('');
    let [actualizarTabla, setActualizarTabla] = useState(false);
    let [mensajeMensaje, setMensajeMensaje] = useState('');
    let [asignacion, setAsignacion] = useState({
        clave_categoria: '',
        listaPrecioId: 0,
        diferencias: '',
        almacenId: 0
    });
    const asignacionRef = useRef(asignacion);

    useEffect(() => { if (asignacionRef) asignacionRef.current = asignacion; }, [asignacion]);

    useEffect(() => {
        function obtenerAlmacenes() {
            fetchConToken(`Almacenes/GetListByPrincipal`).then(function (response) {
                setAlmacenes(response);
                return asignacionRef.current.almacenId = response.find(item => item.es_Ppal === true).id.toString();
            });
        }
        function obtenerPrincipal() {
            fetchConToken(`Sucursales/Principal`).then(function (response) {
                setSucursal(response);
                fetchConToken(`ListaPrecios/GetList?paginas=0&totalXpagina=100&sucursal_Id=${response.id}`).then(function (response2) {
                    setListaPrecio(response2.data);
                    return asignacionRef.current.listaPrecioId = response2.data.find(item => item.es_Principal === true).id.toString();
                });
            });
        }
        const actualizarTitulo = () => {
            setGlobalTitulo(prev => ({
                ...prev,
                titulo: t('app.Articulos.lista.titulo'),
                subtitulo: t('app.Articulos.lista.descripcion')
            }));
        };
        asignacionRef.current.listaPrecioId = obtenerPrincipal();
        asignacionRef.current.almacenId = obtenerAlmacenes();
        setAsignacion({ ...asignacionRef.current });
        actualizarTitulo();
        getConfigERP();
        getTienda();
    }, [setGlobalTitulo, t]);

    useEffect(() => {
        const connect = new HubConnectionBuilder().withUrl(baseUrl + "/notificacion", {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        }).withAutomaticReconnect().build();
        setConnection(connect);
    }, [baseUrl]);

    useEffect(() => {
        if (connection) connection.start().then(async () => {
            await connection.invoke("Add", getDataSession('empresa') + "-" + getDataSession('sucursal'));
            connection.on("ReceiveNotificacionDescarga", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });

            connection.on("ReceiveNotificacionFinalizacion", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });

            connection.on("ReceiveNotificacionAsignacion", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });

            connection.on("ReceiveNotificacionAsignacionVariante", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });

            connection.on("ReceiveNotificacionAsignacionTerminada", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });

            connection.on("DescargarSincronizarArticulo", function (message) {
                setMensajeMensaje(message);
                setActualizarTabla(true);
                setActualizarTabla(false);
            });
        })
        .catch((error) => console.log(error));
    }, [connection]);

    const handleClickHerramientas = (event) => { setAnchorElHerramientas(event.currentTarget); };

    const handleClose = () => {
        setAnchorElHerramientas(null);
    };

    function GetFecha() {
        var curr = new Date();
        curr.setDate(curr.getDate());
        return curr.toISOString().substring(0, 10);
    }

    function publicarExistencia(id) {
        fetchConToken(`Articulos/ActualizarExistenciaArticulo?articulo_id_tienda=${id}&almacen_principal_id=${asignacion.almacenId}&sucursal_tienda=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            Swal.fire(t('app.SwalFire.exitoso'), "Existencia actualizada", 'success');
        });
    }

    function publicarPrecio(id) {
        fetchConToken(`Articulos/ActualizarPrecioArticulo?articulo_id_tienda=${id}&listaprecio_principal_id=${asignacion.listaPrecioId || listaPrecio[0].id}&sucursal_tienda=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            Swal.fire(t('app.SwalFire.exitoso'), "Existencia actualizada", 'success');
        });
    }

    function verHistorial(articulo_id) {
        setArticuloId(articulo_id);
        setModalValor('verHistorialArticulo');
        openModal();
    }

    function sincronizarArticulo(articulo_id) {
        fetchConToken(`Articulos/SincronizarByArticulo?articulo_id=${articulo_id}&sucursal_id=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).map(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
            setActualizarTabla(true);
            setActualizarTabla(false);
        });
    }

    function sincronizarActualizar() {
        handleClose();
        Swal.fire({
            title: '¿Desea actualizar la información de la tabla actual?',
            text: '',
            showDenyButton: true,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Pagina actual',
            denyButtonText: `Todos`
        }).then((result) => {
            if (!(result.isConfirmed || result.isDenied)) return;
            let parametros = `&almacenId=${asignacion?.almacenId || 0}&listaPrecioId=${asignacion?.listaPrecioId || 0}&clave_categoria=${asignacion?.clave_categoria || ''}&filtro_diferencias=${asignacion?.diferencias || ''}&marca=${marca || ''}`;
            parametros = result.isConfirmed ? `${parametros}&pagina=${modelPaginate.page}&totalXpagina=${modelPaginate.pageSize}&busqueda=${buscar}&paginaActual=${result.isConfirmed}` : parametros;
            fetchConToken(`Articulos/DescargarSincronizarArticulos?sucursal_Id=${getDataSession('sucursal')}${parametros}`, null, 'POST').then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const ActualizarArticulo = (articulo_id) => {
        Swal.fire({
            title: isERP() ? '¿Desea actualizar la información de este artículo?' : t('app.Articulos.SwalFire.actualizarArt?'),
            text: isERP() ? '' : t('app.Articulos.SwalFire.infoActArt'),
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(
                    isERP() ? `Articulos/DescargarArticuloERPByArtId?sucursal_id=${getDataSession('sucursal')}&articulo_id=${articulo_id}&crearNoExistentes=true&autoAsignarBySKU=true` :
                        `Articulos/DescargarArticulos?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}&articulo_id=${articulo_id}`,
                    null,
                    'POST'
                ).then(function (response) {
                    if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                    else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                    else {
                        Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                        setActualizarTabla(true);
                        setActualizarTabla(false);
                    }
                });
            }
        })
    };

    function verVariantesArticulo(articulo_id) {
        setArticuloId(articulo_id);
        setModalValor('verVariantesArticulo');
        openModal();
    }

    const handleInput = ({ target }) => {
        if (target.name === 'marca') {
            setMarca(target.value);
            return;
        }

        setAsignacion({
            ...asignacion,
            [target.name]: target.value
        });
    };

    const handleInputCategoria = (value) => {
        setCategoria(value);
        setAsignacion({
            ...asignacion,
            clave_categoria: value?.clave_Categoria || ''
        });
    };

    function handleChangeTipo(e) {
        setFiltroTipo(e.target.value);
    }

    const handleInputChangeFechaInicio = ({ target }) => {
        setFechaInicio(target.value);
    };

    function GetFiltroTipo() {
        return filtroTipo === 'T' ? '' : `&tipo=${filtroTipo}`;
    }

    function movimientoH(value) {
        switch (value) {
            case 'ARTICULO_STOCK': return 'ARTICULO STOCK';
            case 'ARTICULO_PRECIO': return 'ARTICULO PRECIO';
            case 'ARTICULO_VARIANTE': return 'VARIANTE';
            case 'ARTICULO_VARIANTE_STOCK': return 'VARIANTE STOCK';
            case 'ARTICULO_VARIANTE_PRECIO': return 'VARIANTE PRECIO';
            default: return value;
        }
    }

    function movimientoTipo(value) {
        switch (value) {
            case 0: return 'AGREGADO';
            case 1: return 'ACTUALIZADO';
            case 2: return 'DESCARGADO';
            case 3: return 'FOLIADO';
            case 4: return 'FACTURADO';
            case 5: return 'OMITIDO';
            case 6: return 'RECIBIDO';
            case 7: return 'CONSTESTADO';
            case 8: return 'ELIMINADO';
            case 9: return 'CANCELADO';
            case 10: return 'ERROR';
            default: return value;
        }
    }

    function movimientoClave(row, value) {
        switch (row.movimiento) {
            case 'VENTA': return row.venta ? <a href={`${SLUGS.remisiones + '/edit/' + row.venta?.id}`}>{row.venta?.no_Orden}</a> : value;
            case 'ARTICULO':
            case 'ARTICULO_STOCK':
            case 'ARTICULO_PRECIO': return row.articulo ? <a href={`${SLUGS.articulos + '/edit/' + row.articulo?.id}`}>{row.articulo?.clave}</a> : value;
            case 'ARTICULO_VARIANTE':
            case 'ARTICULO_VARIANTE_STOCK':
            case 'ARTICULO_VARIANTE_PRECIO': return row.articulo_Variante ? <a href={`${SLUGS.articulos + '/edit/' + row.articulo_Variante?.articulo_Id}`}>{row.articulo_Variante?.clave}</a> : value;
            default: return value;
        }
    }

    function GetFoliosERP(row) {
        if (row.venta.documento_FoliosOrigen && row.venta.documento_FoliosOrigen.length > 0) return row.venta.documento_FoliosOrigen?.map(objeto => objeto.erp_Folio)?.join(', ');

        return '~';
    }

    function DatosExtra(row) {
        switch (row.movimiento) {
            case 'VENTA': return !row.venta ? '' :
                <ListItemText
                    primary={`Folio: ${row.venta.folio},  Folio ERP: ${GetFoliosERP(row)},  Fecha: ${moment(row.venta.fecha_Orden).format('DD/MM/Y')}`}
                    secondary={
                        <React.Fragment>
                            <Typography component="span" variant="body2" sx={{ color: 'text.primary', display: 'inline' }}>{row.venta.cliente?.nombre ?? ''},</Typography>
                            &nbsp;{`Importe Total: ${currency(row.venta.importe_Total)},  Estatus: ${row.venta.estatus}`}
                        </React.Fragment>
                    }
                />;
            case 'ARTICULO':
            case 'ARTICULO_STOCK':
            case 'ARTICULO_PRECIO': return !row.articulo ? '' :
                <ListItemText
                    primary={`${row.articulo.nombre},  SKU: ${row.articulo.sku}`}
                    secondary={`Precio: ${currency(row.articulo.costo_Unidad)},  Exist.: ${row.articulo.existencias},  Estatus: ${row.articulo.estatus}`}
                />;
            case 'ARTICULO_VARIANTE':
            case 'ARTICULO_VARIANTE_STOCK':
            case 'ARTICULO_VARIANTE_PRECIO': return !row.articulo_Variante ? '' :
                <ListItemText
                    primary={`${row.articulo_Variante.nombre},  SKU: ${row.articulo_Variante.sku}`}
                    secondary={`Precio: ${currency(row.articulo_Variante.precio)},  Exist.: ${row.articulo_Variante.existencias},  Estatus: ${row.articulo_Variante.estatus}`}
                />;
            default: return '';
        }
    }

    function getConfigERP() {
        fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=ERP`).then((r) => setERP(r.valor));
    }

    const getTienda = () => {
        fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=TIENDA`).then((response) => {
            setTienda(response.valor);
            if (response.valor === 'SHOPIFY') fetchConToken(`Articulos/MarcasArticulosBySucursalId?sucursalId=${response.sucursal_Id}`).then(response => setMarcas(response));
        });
    }

    function isERP() {
        return erp === 'OKCAR' || erp === 'SICARX';
    }

    function isShopify() {
        return tienda === 'SHOPIFY';
    }

    function regresar() {
        handleClose();
        history.push(`${SLUGS.articulos}`);
    }

    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "publicarExistencia,publicarPrecio,sincronizarArticulo,verHistorial,actualizararticulo,verVariantesArticulo", publicarExistencia: publicarExistencia, publicarPrecio: publicarPrecio, sincronizarArticulo: sincronizarArticulo, verHistorial: verHistorial, actualizararticulo: ActualizarArticulo, verVariantesArticulo: verVariantesArticulo },
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'sku', headerName: 'SKU', flex: 1 },
        { field: 'nombre', headerName: 'Articulo', flex: 1 },
        { field: 'es_Variante', headerName: 'Tiene Variantes', flex: 1 },
        { field: 'existencia', headerName: 'Exist. Ecommerce', flex: 1 },
        { field: 'precio', headerName: 'Precio Ecommerce', flex: 1, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'skuPrincipal', headerName: 'SKU', flex: 1 },
        { field: 'nombrePrincipal', headerName: 'Articulo', flex: 1 },
        { field: 'existenciaPrincipal', headerName: 'Exist. Principal', flex: 1 },
        { field: 'precioPrincipal', headerName: 'Precio Principal', flex: 1, type: 'number', renderCell: ({ value }) => currency(value) }
    ];

    const columnsVariantes = [
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'sku', headerName: 'SKU', flex: 1 },
        { field: 'nombre', headerName: 'Articulo', flex: 1 },
        { field: 'existencia', headerName: 'Exist. Ecommerce', flex: 1 },
        { field: 'precio', headerName: 'Precio Ecommerce', flex: 1, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'skuPrincipal', headerName: 'SKU', flex: 1 },
        { field: 'nombrePrincipal', headerName: 'Articulo', flex: 1 },
        { field: 'existenciaPrincipal', headerName: 'Exist. Principal', flex: 1 },
        { field: 'precioPrincipal', headerName: 'Precio Principal', flex: 1, type: 'number', renderCell: ({ value }) => currency(value) }
    ];

    const columnsHistorial = [
        { field: 'fecha_Registro', headerName: 'Fecha', minWidth: 160 },
        { field: 'movimiento', headerName: 'Movimiento', minWidth: 160, renderCell: (params) => movimientoH(params.value) },
        { field: 'clave', headerName: 'Clave', minWidth: 160, renderCell: (params) => movimientoClave(params.row, params.value) },
        { field: 'movimiento_Tipo', headerName: 'Tipo', minWidth: 150, renderCell: (params) => movimientoTipo(params.value) },
        { field: 'item', headerName: 'Datos Extra', minWidth: 475, renderCell: (params) => DatosExtra(params.row) },
        { field: 'mensaje', headerName: 'Mensaje', minWidth: 300 }
    ];

    return (<>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-2'>
                    <p>Lista de precio:</p>
                    <select
                        className='form-select'
                        name='listaPrecioId'
                        value={asignacion?.listaPrecioId}
                        onChange={handleInput}
                        required
                    >
                        {listaPrecio.map((rol) => { return (<option key={rol.id} value={rol.id}>{rol.nombre}</option>); })}
                    </select>
                </div>
                <div className='col-md-2'>
                    <p>Almacen:</p>
                    <select
                        className='form-select'
                        name='almacenId'
                        value={asignacion?.almacenId}
                        onChange={handleInput}
                        required
                    >
                        {almacenes.map((rol) => { return (<option key={rol.id} value={rol.id}>{rol.nombre}</option>); })}
                    </select>
                </div>
                <div className='col-md-2'>
                    <p>Filtro:</p>
                    <select
                        className='form-select'
                        name='diferencias'
                        value={asignacion?.diferencias}
                        onChange={handleInput}
                        required
                    >
                        <option key='T' value='T'>Todos</option>
                        <option key='P' value='P'>Con Diferencias de precio</option>
                        <option key='S' value='S'>Con Diferencias de stock</option>
                        <option key='ASIGNADO' value='ASIGNADO'>Asignados</option>
                        <option key='N_ASIGNADO' value='N_ASIGNADO'>No Asignados</option>
                    </select>
                </div>
                {isShopify() && <div className='col-md-2'>
                    <p>Marca:</p>
                    <select
                        className='form-select'
                        name='marca'
                        value={marca}
                        onChange={handleInput}
                        required
                    >
                        <option key='' value=''>Todos</option>
                        {marcas.map((aux) => { return (<option key={aux} value={aux}>{aux}</option>); })}
                    </select>
                </div>}
                <div className={isShopify() ? 'col-md-2' : 'col-md-3'}>
                    <p>Categoria:</p>
                    <AsyncSelectTextField
                        getOptionLabel={(option) => option.clave_Categoria + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave_Categoria}
                        valueSelectTo={categoria}
                        setValueSelectTo={handleInputCategoria}
                        url={`Categorias/GetList?pagina=0&totalXpagina=50&sucursal_Id=${getDataSession('sucursal')}`}
                    />
                </div>
                <div className={isShopify() ? 'col-md-2' : 'col-md-3'}>
                    <p>Conexion principal: </p>
                    <p><b>&nbsp;&nbsp;{sucursal.nombre}</b></p>
                    <div className='col-md-12 text-right'>
                        <button
                            className='btn btn-outline-primary m-1'
                            onClick={handleClickHerramientas}
                            style={{ width: 'auto' }}
                        >
                            {t('app.botones.herramientas')} <ArrowDropDownIcon />
                        </button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorElHerramientas}
                            open={openHerramientas}
                            onClose={handleClose}
                            MenuListProps={{ 'aria-labelledby': 'basic-button', }}
                        >
                            <MenuItem onClick={() => sincronizarActualizar()}>
                                <ListItemIcon>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-reply'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                                    </svg>
                                </ListItemIcon>
                                Sincronizar/Actualizar
                            </MenuItem>
                            <MenuItem onClick={() => regresar()}>
                                <ListItemIcon>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-reply'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                                    </svg>
                                </ListItemIcon>
                                {t('app.botones.regresar')}
                            </MenuItem>
                        </Menu>
                    </div>
                    <p>{mensajeMensaje}</p>
                </div>
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    url={`Articulos/GetListComparativa?sucursal_Id=${getDataSession('sucursal')}&almacenId=${asignacion?.almacenId || 0}&listaPrecioId=${asignacion?.listaPrecioId || 0}&clave_categoria=${asignacion?.clave_categoria || ''}&filtro_diferencias=${asignacion?.diferencias || ''}&marca=${marca || ''}`}
                    isTreeData={true}
                    setModelPaginate={setModelPaginate}
                    setBuscar={setBuscar}
                />
            </div>
        </div>
        <Modal isOpen={isOpenModal} closeModal={closeModal}>
            <div className='espacio15px' />
            {modalValor === 'verHistorialArticulo' && <>
                <div className='card' style={{ height: "50vh" }}>
                    <div className='col-md-12'>
                        <div className='espacio5px' />
                        <div className='col-12 col-sm-12 col-md-12 row'>
                            <div className='col-sm-1'><div className='espacio10px' /><label className='form-label title2'>&nbsp; Historial</label></div>
                            <div className='col-sm-7' />
                            <div className='col-sm-2'>
                                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                    <InputLabel id="tipo-label">Tipo</InputLabel>
                                    <Select id="tipo" labelId="tipo-label" label="Tipo" onChange={handleChangeTipo} value={filtroTipo}>
                                        <MenuItem key="TodosFiltros" value="T"><ListItemText primary="Todos" /></MenuItem>
                                        <MenuItem key="Asignados" value="AGREGADO"><ListItemText primary="Agregado" /></MenuItem>
                                        <MenuItem key="NoAsignados" value="ACTUALIZADO"><ListItemText primary="Actualizado" /></MenuItem>
                                        <MenuItem key="ConVariantes" value="DESCARGADO"><ListItemText primary="Descargado" /></MenuItem>
                                        <MenuItem key="Asignados" value="OMITIDO"><ListItemText primary="Omitido" /></MenuItem>
                                        <MenuItem key="ConVariantes" value="ERROR"><ListItemText primary="Error" /></MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='col-sm-2'>
                                <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                    label="Fecha"
                                    type="date"
                                    value={fechaInicio}
                                    onChange={handleInputChangeFechaInicio}
                                    InputLabelProps={{ shrink: true, }}
                                />
                            </div>
                        </div>
                    </div>
                    <ListTable
                        columns={columnsHistorial}
                        url={`LogNotificacion/Historial/GetListByMovimiento?sucursal_id=${getDataSession('sucursal')}&movimiento_id=${articuloId}&movimiento=ARTICULO&fecha=${fechaInicio}${GetFiltroTipo()}`}
                        hideSearch={true}
                        reload={actualizarTabla}
                    />
                </div>
            </>}
            {modalValor === 'verVariantesArticulo' && <>
                <div className='card' style={{ height: "50vh" }}>
                    <ListTable
                        columns={columnsVariantes}
                        url={`Articulos/GetListComparativa?sucursal_Id=${getDataSession('sucursal')}&articulo_id=${articuloId}&almacenId=${asignacion?.almacenId || 0}&listaPrecioId=${asignacion?.listaPrecioId || 0}&clave_categoria=${asignacion?.clave_categoria || ''}&filtro_diferencias=${asignacion?.diferencias || ''}&marca=${marca || ''}&variantes=true`}
                        hideSearch={true}
                        isTreeData={true}
                    />
                </div>
            </>}
        </Modal>
    </>);
};

const DiferenciasByArt = ({ history, match }) => {
    const { id } = match.params;
    const { t } = useTranslation("common");
    const { changeGlobalTitle } = useUIUtils()
    const [modalValor, setModalValor] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    let [articuloComparativo, setArticuloComparativo] = useState({});
    let [sucursal, setSucursal] = useState({});
    let [listaPrecio, setListaPrecio] = useState([]);
    let [almacenes, setAlmacenes] = useState([]);
    let [asignacion, setAsignacion] = useState({
        listaPrecioId: 0,
        almacenId: 0,
    });

    const handleClick = (event) => { setAnchorEl(event.currentTarget); };

    const handleClose = () => { setAnchorEl(null); };

    React.useEffect(() => {
        function obtenerPrincipal() {
            fetchConToken(`Sucursales/Principal`).then(function (response) {
                setSucursal(response);
                fetchConToken(`ListaPrecios/GetList?paginas=0&totalXpagina=100&sucursal_Id=${response.id}`).then(function (response2) {
                    setListaPrecio(response2.data);
                    return asignacion.listaPrecioId = response2.data.find(item => item.es_Principal === true).id.toString();
                });
            });
        }
        function getArticuloComparativo() {
            setArticuloComparativo({});
            fetchConToken(`Articulos/GetListComparativa?sucursal_Id=${getDataSession('sucursal')}&almacenId=${asignacion?.almacenId || 0}&listaPrecioId=${asignacion?.listaPrecioId || 0}&articulo_id=${id}&paginas=${0}&totalXpagina=${10}`).then(art => {
                if (art.hasOwnProperty('status')) {
                    Object.entries(art?.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error');
                        history.push(SLUGS.articulos);
                    });
                    return false;
                } else if (art.hasOwnProperty('codigo')) {
                    Swal.fire('Error', art.mensajes[0], 'error');
                    history.push(SLUGS.articulos);
                    return;
                }

                if (art.data && art.data.filter(x => x.id === id).length > 0) setArticuloComparativo(art.data.filter(x => x.id === id)[0]);
            });
        }
        function obtenerAlmacenes() {
            fetchConToken(`Almacenes/GetListByPrincipal`).then(function (response) {
                setAlmacenes(response);
                return asignacion.almacenId = response.find(item => item.es_Ppal === true).id.toString();
            });
        }
        asignacion.listaPrecioId = obtenerPrincipal();
        asignacion.almacenId = obtenerAlmacenes();
        changeGlobalTitle(t('app.Articulos.lista.titulo'), t('app.Articulos.lista.descripcion'))
        setAsignacion(prev => prev);
        getArticuloComparativo();
    }, [changeGlobalTitle, asignacion, history, id, t]);

    // function getArticulo() {
    //     fetchConToken(`articulos?id=${id}&sucursal_Id=${getDataSession('sucursal')}&conDetalle=true`).then(art => {
    //         if (art.hasOwnProperty('status')) {
    //             Object.entries(art?.errors).map(([key, value]) => {
    //                 Swal.fire('Error', value[0], 'error');
    //                 history.push(SLUGS.articulos);
    //                 return;
    //             });
    //             return false;
    //         } else if (art.hasOwnProperty('codigo')) {
    //             Swal.fire('Error', art.mensajes[0], 'error');
    //             history.push(SLUGS.articulos);
    //             return;
    //         }

    //         setArticulo(art);
    //     });
    // }

    const handleInput = ({ target }) => {
        console.log(asignacion);
        setAsignacion({
            ...asignacion,
            [target.name]: target.value
        });
    };

    function handleClickMenuInventory(event) {
        setModalValor('STOCK');
        handleClick(event);
    }

    function handleClickMenuPrecio(event) {
        setModalValor('PRECIO');
        handleClick(event);
    }

    function publicarExistencia() {
        fetchConToken(`Articulos/ActualizarExistenciaArticulo?articulo_id_tienda=${id}&almacen_principal_id=${asignacion.almacenId}&sucursal_tienda=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');

                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            Swal.fire(t('app.SwalFire.exitoso'), "Existencia actualizada", 'success');
        });
    }

    function publicarPrecio() {
        fetchConToken(`Articulos/ActualizarPrecioArticulo?articulo_id_tienda=${id}&listaprecio_principal_id=${asignacion.listaPrecioId || listaPrecio[0].id}&sucursal_tienda=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => {
                    Swal.fire('Error', value[0], 'error');

                });
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }
            Swal.fire(t('app.SwalFire.exitoso'), "Existencia actualizada", 'success');
        });
    }

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-4'>
                    <p>Conexion principal: </p>
                    <p><b>&nbsp;&nbsp;{sucursal.nombre}</b></p>
                </div>
                <div className='col-md-4'>
                    <p>Lista de precio:</p>
                    <select
                        className='form-control'
                        name='listaPrecioId'
                        value={asignacion?.listaPrecioId}
                        onChange={handleInput}
                        required
                    >
                        {listaPrecio.map((rol) => {
                            return (
                                <option key={rol.id} value={rol.id}>
                                    {rol.nombre}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className='col-md-4'>
                    <p>Almacen:</p>
                    <select
                        className='form-control'
                        name='almacenId'
                        value={asignacion?.almacenId}
                        onChange={handleInput}
                        required
                    >
                        {almacenes.map((rol) => {
                            return (
                                <option key={rol.id} value={rol.id}>
                                    {rol.nombre}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <div className='espacio30px' />
            <div className='col-md-12 row'>
                <div className='col-md-1' />
                <List className='col-md-5'>
                    <ListItem alignItems="flex-start">
                        <ListItemText
                            primary=''
                            secondary={
                                <React.Fragment>
                                    <div className='col-md-12 row'>
                                        <div className='col-md-5' />
                                        <div className='col-md-4'>Articulo</div>
                                        <div className='col-md-3' /></div>
                                </React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><AssignmentIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.nombreArt') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.nombre}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><ConfirmationNumberIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={'SKU:'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.sku}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start"
                        secondaryAction={
                            <IconButton aria-label="comment" onClick={handleClickMenuInventory}>
                                <MoreVertIcon />
                            </IconButton>
                        }>
                        <ListItemAvatar><Avatar><InventoryIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.existencias') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.existencia}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start"
                        secondaryAction={
                            <IconButton aria-label="comment" onClick={handleClickMenuPrecio}>
                                <MoreVertIcon />
                            </IconButton>
                        }>
                        <ListItemAvatar><Avatar><AttachMoneyIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.precioArt') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.precio}</React.Fragment>}
                        />
                    </ListItem>
                </List>
                <div className='col-md-1' />
                <List className='col-md-5'>
                    <ListItem alignItems="flex-start">
                        <ListItemText
                            primary=''
                            secondary={
                                <React.Fragment>
                                    <div className='col-md-12 row'>
                                        <div className='col-md-4' />
                                        <div className='col-md-4'>Articulo Principal</div>
                                        <div className='col-md-4' /></div>
                                </React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><AssignmentIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.nombreArt') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.nombrePrincipal}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><ConfirmationNumberIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={'SKU:'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.skuPrincipal}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><InventoryIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.existencias') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.existenciaPrincipal}</React.Fragment>}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar><Avatar><AttachMoneyIcon /></Avatar></ListItemAvatar>
                        <ListItemText
                            primary={t('app.Articulos.form.precioArt') + ':'}
                            secondary={<React.Fragment>&nbsp; &nbsp; &nbsp; {articuloComparativo.precioPrincipal}</React.Fragment>}
                        />
                    </ListItem>
                </List>
            </div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'basic-button', }}
            >
                {modalValor === 'STOCK' && <MenuItem onClick={(e) => { publicarExistencia(); handleClose(); }}><ListItemIcon><LoyaltyIcon /></ListItemIcon>Publicar Existencia</MenuItem>}
                {modalValor === 'PRECIO' && <MenuItem onClick={(e) => { publicarPrecio(); handleClose(); }}><ListItemIcon><LoyaltyIcon /></ListItemIcon>Publicar Precio</MenuItem>}

            </Menu>
        </div>
    );
}

export { DiferenciasArt, DiferenciasByArt };